export const wmIT = {
  'skitouring': 'Scialpinismo',
  'horse': 'A cavallo',
  'walking': 'Passeggiata',
  'running': 'Corsa',
  'asphalt': 'Asfalto',
  'bitumenduro': 'Bitumenduro',
  'onoff': 'Onoff',
  'real_dirt': 'Sterrato vero',
  'bar': 'Bar',
  'cycling': 'In bicicletta',
  'poi_type': 'Punti di interesse',
  'where': 'Luoghi',
  'lang': 'Lingua',
  'langPlaceholder': 'Seleziona',
  'from': 'Partenza',
  'to': 'Arrivo',
  'ascent': 'Dislivello positivo',
  'descent': 'Dislivello negativo',
  'distance': 'Distanza',
  'da te': 'da te',
  'ele_from': 'Quota di partenza',
  'ele_max': 'Quota massima',
  'ele_min': 'Quota minima',
  'ele_to': 'Quota di arrivo',
  'difficulty': 'Difficoltà',
  'cai_scale': 'Scala di difficoltà CAI',
  'duration_forward': 'Durata di andata',
  'duration_backward': 'Durata di ritorno',
  'Filtri': 'Filtri',
  'Cerca': 'Ricerca',
  'tracce': 'Tracce',
  'hiking': 'Escursionismo',
  'Escursionismo': 'Escursionismo',
  'escursionismo': 'Escursionismo',
  'i miei percorsi': 'Disegna percorso',
  'metri': 'Metri',
  'Vedi su OpenStreetMap': 'Vedi su OpenStreetMap',
  'Descrizione Audio': 'Descrizione Audio',
  'il tuo browser non supporta gli elementi audio':
    'Il tuo browser non supporta gli elementi audio.',
  'stampa': 'Stampa',
  'Difficoltà': 'Difficoltà',
  'Scala di difficoltà CAI': 'Échelle de difficulté CAI',
  'Questo percorso non è accessibile': 'Questo percorso non è accessibile',
  'Descrizione': 'Descrizione',
  'Punto di partenza': 'Punto di partenza',
  'Punto di arrivo': 'Punto di arrivo',
  'Dettagli tecnici': 'Dettagli tecnici',
  'Attività': 'Attività',
  'Come arrivare': 'Come arrivare',
  'Bici muscolari': 'Bici muscolari',
  'Bici elettriche': 'Bici elettriche',
  'Mezzi pubblici': 'Mezzi pubblici',
  'Auto Propria': 'Auto Propria',
  'Punti di interesse': 'POI',
  'Punto di interesse': 'POI',
  'Collegamenti esterni': 'Collegamenti esterni',
  'Downloads': 'Downloads',
  'edit geohub': 'Modifica geohub',
  'NCC': 'NCC',
  'Filtri attivi': 'Filtri attivi',
  'Reset filtri': 'Reset filtri',
  'Torna alla home': 'Torna alla home',
  'Risultati': 'Risultati',
  'Caricamento in corso.': 'Caricamento in corso.',
  'Spiacenti non ci sono risultati con questi criteri di ricerca.':
    'Spiacenti non ci sono risultati con questi criteri di ricerca.',
  'duration': 'Durata',
  'Bentornato!': 'Bentornato!',
  'Accedi con le tue credenziali per continuare.': 'Accedi con le tue credenziali per continuare.',
  'E-mail': 'E-mail',
  "L'e-mail è obbligatoria": "L'e-mail è obbligatoria",
  "Hai inserito un'e-mail non valida": "Hai inserito un'e-mail non valida",
  'Password': 'Password',
  'La password è obbligatoria': 'La password è obbligatoria',
  'Accedi': 'Accedi',
  'Hai dimenticato la password?': 'Hai dimenticato la password?',
  'Accedi e scarica i tuoi percorsi preferiti': 'Accedi e scarica i tuoi percorsi preferiti',
  'Puoi anche condividerli con i tuoi compagni di viaggio':
    'Puoi anche condividerli con i tuoi compagni di viaggio',
  'Registrati': 'Registrati',
  'Tracce scaricate': 'Tracce scaricate',
  'Utilizzo dati': 'Utilizzo dati',
  'Registrazioni': 'Registrazioni',
  'Photos': 'Foto',
  'Waypoint': 'Waypoint',
  'elimina': 'elimina',
  'Nome': 'Nome',
  'inserisci il tuo nome': 'inserisci il tuo nome',
  "E' necessario inserire un nome": "E' necessario inserire un nome",
  'inserisci il tuo cognome': 'inserisci il tuo cognome',
  "E' necessario inserire un cognome": "E' necessario inserire un cognome",
  'Email': 'Email',
  "E' necessario inserire una email": "E' necessario inserire una email",
  "L'email inserita non è un'email valida": "L'email inserita non è un'email valida",
  'Codice Fiscale': 'Codice Fiscale',
  'Perché ti chiediamo il CF?': 'Perché ti chiediamo il CF?',
  'Il codice fiscale inserito non è valido': 'Il codice fiscale inserito non è valido',
  'inserisci password': 'inserisci password',
  "E' necessario inserire la password": "E' necessario inserire la password",
  'Conferma password': 'Conferma password',
  'Ripeti password': 'Ripeti password',
  "E' necessario confermare la password": "E' necessario confermare la password",
  'La conferma non corrisponde con la password inserita sopra':
    'La conferma non corrisponde con la password inserita sopra',
  'Cliccando su "Registrati" accetti la nostra': 'Cliccando su "Registrati" accetti la nostra',
  'e i': 'e i',
  'Termini e condizioni': 'Termini e condizioni',
  "Errore durante la registrazione dell'utente": "Errore durante la registrazione dell'utente",
  'Registrazione in corso': 'Registrazione in corso',
  'Perchè ti chiediamo il Codice Fiscale?': 'Perchè ti chiediamo il Codice Fiscale?',
  'Se sei Socia/o CAI inserisci il tuo CF al momento della registrazione. Per te il download delle tappe del Sentiero Italia CAI sarà automaticamente gratuito!':
    'Se sei Socia/o CAI inserisci il tuo CF al momento della registrazione. Per te il download delle tappe del Sentiero Italia CAI sarà automaticamente gratuito!',
  "Origine dell'immagine": "Origine dell'immagine",
  'Annulla': 'Annulla',
  'Dalla libreria': 'Dalla libreria',
  'Scatta una foto': 'Scatta una foto',
  'placeholder': 'Cerca',
  'Carica File': 'Carica File',
  'Trascina qui il tuo file o clicca per selezionare':
    'Trascina qui il tuo file o clicca per selezionare',
  'Accetta i seguenti formati': 'Accetta i seguenti formati',
  'Tipo di file non supportato': 'Tipo di file non supportato',
  'Il file non contiene una geometria valida': 'Il file non contiene una geometria valida',
  'Errore durante la lettura del file, riprova': 'Errore durante la lettura del file, riprova',
  'Si è verificato un errore durante il salvataggio della traccia. Riprova':
    'Si è verificato un errore durante il salvataggio della traccia. Riprova',
  'La traccia è stata salvata correttamente': 'La traccia è stata salvata correttamente',
  'Scarica il tracciato GPX': 'Scarica il tracciato GPX',
  'Scarica il tracciato KML': 'Scarica il tracciato KML',
  'Scarica il tracciato GEOJSON': 'Scarica il tracciato GEOJSON',
  'Link utili': 'Link utili',
  'apri pdf': 'Apri PDF',
  'pendenza': 'Pendenza',
  'Galleria': 'Galleria',
  'resetta la memoria': 'Resetta la memoria',
  'rimani acceso': 'Rimani acceso',
  'forza il dispositivo a non spegnersi': 'Forza il dispositivo a non spegnersi',
  'PAGINE': 'PAGINE',
  'I tuoi dati': 'I tuoi dati',
  'pages.profile.projectlink': 'Progetto',
  'pages.profile.disclaimerlink': 'Disclaimer',
  'pages.profile.creditslink': 'Credits',
  'pages.profile.privacylink': 'Privacy',
  'pages.profile.title': 'Profilo',
  'MEMORIA': 'MEMORIA',
  'la distanza espressa in metri che indica la cadenza di rilevamento posizione, più il distance filter è minore piu il consumo della batteria sarà maggiore.':
    'Distanza espressa in metri che indica la cadenza di rilevamento posizione, più il distance filter è minore piu il consumo della batteria sarà maggiore.',
  "Per registrare tracce e poi correttamente, abilita l'autorizzazione alla posizione nelle impostazioni":
    "Per registrare tracce e poi correttamente, abilita l'autorizzazione alla posizione nelle impostazioni",
  'I miei percorsi': 'I miei percorsi',
  'Sentieri': 'Sentieri',
  'Sentiero': 'Sentiero',
  'layers': 'Layers',
  '<span class="green">Livello 1: tratti non interessati dall\'alta quota (quota minore di {{orange}} metri)</span>':
    '<span class="green">Livello 1: tratti non interessati dall\'alta quota (quota minore di {{orange}} metri)</span>',
  '<span class="orange">Livello 2: tratti parzialmente in alta quota (quota compresa tra {{orange}} metri e {{red}} metri)</span>':
    '<span class="orange">Livello 2: tratti parzialmente in alta quota (quota compresa tra {{orange}} metri e {{red}} metri)</span>',
  '<span class="red">Livello 3: in alta quota (quota superiore {{red}} metri)</span>':
    '<span class="red">Livello 3: in alta quota (quota superiore {{red}} metri)</span>',
  'Un utente è già stato registrato con questa email.':
    'Un utente è già stato registrato con questa email.',
  "L'email inserita non è corretta. Per favore, riprova.":
    "L'email inserita non è corretta. Per favore, riprova.",
  'La password inserita non è corretta. Per favore, riprova.':
    'La password inserita non è corretta. Per favore, riprova.',
  'Errore': 'Errore',
  'Tempo': 'Tempo',
  'Velocità media': 'Velocità media',
  'Velocità massima': 'Velocità massima',
  'Tipologia di form': 'Tipologia di form',
  'Seleziona il tipo di form': 'Seleziona il tipo di form',
  'File selezionato': 'File selezionato',
  'Carica': 'Carica',
  'Aggiornamento effettuato con successo': 'Aggiornamento effettuato con successo',
  'Ops!': 'Ops!',
  'Non è stato possibile aggiornare, riprova più tardi':
    'Non è stato possibile aggiornare, riprova più tardi',
  'Eliminazione effettuata con successo': 'Eliminazione effettuata con successo',
  'Sicuro di voler eliminare questo POI? La rimozione è irreversibile.':
    'Sicuro di voler eliminare questo POI? La rimozione è irreversibile.',
  'Sicuro di voler eliminare questa traccia? La rimozione è irreversibile.':
    'Sicuro di voler eliminare questa traccia? La rimozione è irreversibile.',
  'Login effettuato con successo': 'Login effettuato con successo',
  'Logout effettuato con successo': 'Logout effettuato con successo',
  'Ottieni indicazioni': 'Ottieni indicazioni',
  'Mostra altro': 'Mostra altro',
  'Distanza da te': 'Distanza da te',
  'Mostra meno': 'Mostra meno',
  'Mostra tutti': 'Mostra tutti',
  'Lunghezza': 'Lunghezza',
  'Orario previsto': 'Orario previsto',
  'Dimensione': 'Dimensione',
  'questo campo è obbligatorio': 'questo campo è obbligatorio',
  'Quota': 'Quota',
  'I miei downloads': 'I miei downloads',
  'foto dalla galleria': 'foto dalla galleria',
  'Dimensione massime: 3 photo': 'Dimensione massime: 3 photo',
  'Aggiungi': 'Aggiungi',
  'Foto': 'Foto',
  '(max 3 photo)': '(max 3 photo)',
  'art-and-culture': 'Arte e cultura',
  'tourism': 'Turismo',
  'e-bike': 'Bici elettrica',
  'touring-bike': 'Bici da turismo',
  'train-trekking': 'Treno trekking',
  'road-bike': 'Bici da strada',
  'ciaspole': 'Ciaspole',
  'adventure': 'Avventura',
  'swimming-snorkeling': 'Nuoto e snorkeling',
  'birdwatching': 'Birdwatching',
  'oeno-gastronomy': 'Oeno-gastronomia',
  'nordic-walking': 'Nordic walking',
  'joelette': 'Joelette',
  'mtb': 'MTB',
  'mountain-bike': 'Mountain bike',
  'Ottieni le indicazioni su Google Maps': 'Ottieni le indicazioni su Google Maps',
  'Per il punto di partenza': 'Per il punto di partenza',
  "Per il punto più vicino in linea d'aria": "Per il punto più vicino in linea d'aria",
  'Tipo di form': 'Tipo di form',
  'massimo': 'massimo',
  'foto': 'foto',
  'Carica foto dalla libreria': 'Carica foto dalla libreria',
  'Luogo': 'Luogo',
  'Luoghi': 'Luoghi',
  'Percorso': 'Percorso',
  'Percorsi': 'Percorsi',
  'salva': 'salva',
  'Il salvataggio è stato completato': 'Il salvataggio è stato completato',
  'Stai modificando le coordinate del POI, vuoi continuare?':
    'Stai modificando le coordinate del POI, vuoi continuare?',
  'No': 'No',
  'Sì': 'Sì',
  'Attenzione': 'Attenzione',
  'Disegna': 'Disegna',
  'Esci': 'Esci',
  'Hai salvato correttamente il tuo waypoint. Puoi visualizzarlo accedendo al tuo profilo.':
    'Hai salvato correttamente il tuo waypoint. Puoi visualizzarlo accedendo al tuo profilo.',
  'Cliccando su "Registrati" accetti la nostra privacy e i termini e condizioni':
    'Cliccando su "Registrati" accetti la nostra privacy e i termini e condizioni',
  'culture-history': 'Cultura e storia',
  'environmental-education': 'Educazione ambientale',
  'eating-sleeping': 'Mangiare e dormire',
  'by-car': 'In macchina',
  'Eliminazione': 'Eliminazione',
  'Elimina': 'Elimina',
  'Sei sicuro di voler eliminare questi dati?': 'Sei sicuro di voler eliminare questi dati?',
  'Modifica consenso dati': 'Modifica consenso dati',
  'Dati non sincronizzati': 'Dati non sincronizzati',
  'Lingua': 'Lingua',
  'Azione irreversibile': 'Azione irreversibile',
  'Vuoi veramente eliminare il tuo account? È obbligatorio scrivere "delete account" per procedere.':
    'Vuoi veramente eliminare il tuo account? È obbligatorio scrivere "delete account" per procedere.',
  'Digita "delete account"': 'Digita "delete account"',
  'Conferma': 'Conferma',
  'La conferma non corrisponde. Digita "delete account" per procedere.':
    'La conferma non corrisponde. Digita "delete account" per procedere.',
  'Elimina account': 'Elimina account',
  'Aggiornamento disponibile': 'Aggiornamento disponibile',
  "È disponibile una nuova versione dell'app. Aggiorna per ottenere le ultime funzionalità e miglioramenti.":
    "È disponibile una nuova versione dell'app. Aggiorna per ottenere le ultime funzionalità e miglioramenti.",
  'Aggiorna ora': 'Aggiorna ora',
  'Più tardi': 'Più tardi',
  'Versione disponibile': 'Versione disponibile',
  'È stata rilevata una registrazione interrotta. Vuoi riprenderla?':
    'È stata rilevata una registrazione interrotta. Vuoi riprenderla?',
  'Riprendi': 'Riprendi',
  'Info': 'Info',
  'Chiudi': 'Chiudi',
  'Store non disponibile': 'Store non disponibile',
  "Non è stato possibile aprire direttamente lo store. Prova ad aprire manualmente la pagina dell'app nello store.":
    "Non è stato possibile aprire direttamente lo store. Prova ad aprire manualmente la pagina dell'app nello store.",
  'Aggiornamento obbligatorio': 'Aggiornamento obbligatorio',
  "Per continuare a utilizzare l'app è necessario installare l'ultima versione disponibile.":
    "Per continuare a utilizzare l'app è necessario installare l'ultima versione disponibile.",
  "È disponibile una nuova versione dell'app.": "È disponibile una nuova versione dell'app.",
  "Dove": "Dove",
  "Regione": "Regione",
  "Provincia": "Provincia",
  "Comune": "Comune",
  'layer': 'Layer',
  'Nessun risultato': 'Nessun risultato',
  'Condividi': 'Condividi',
  'Condivisione in corso': 'Condivisione in corso',
  'Condivisione non riuscita': 'Condivisione non riuscita',
  'Riprova': 'Riprova',
  'Aggiungi ai preferiti': 'Aggiungi ai preferiti',
  'Rimuovi dai preferiti': 'Rimuovi dai preferiti',
  'Preferito': 'Preferito',
  'Non preferito': 'Non preferito',
  'Impossibile aggiornare i preferiti, riprova': 'Impossibile aggiornare i preferiti, riprova',
  'Modifica profilo': 'Modifica profilo',
  'Cambia foto': 'Cambia foto',
  'Il nome è obbligatorio': 'Il nome è obbligatorio',
  'Il nome non può superare i 255 caratteri': 'Il nome non può superare i 255 caratteri',
  'Cognome': 'Cognome',
  'Il cognome non può superare i 255 caratteri': 'Il cognome non può superare i 255 caratteri',
  'Salva': 'Salva',
};
